/**
 * Сетка видеовизиток на Contact.
 */

import { TEAM_COPY, TEAM_MEMBERS } from "../../config/team";
import TeamCard from "./TeamCard";
import "./TeamCards.css";

function TeamCards() {
    return (
        <section className="team-cards" aria-label={TEAM_COPY.label}>
            <p className="team-cards__label">{TEAM_COPY.label}</p>
            <div className="team-cards__grid">
                {TEAM_MEMBERS.map((member) => (
                    <TeamCard key={member.id} member={member} />
                ))}
            </div>
        </section>
    );
}

export default TeamCards;
// components/TeamCards/TeamCards.js
